import { render, staticRenderFns } from "./BidHistoryItem.vue?vue&type=template&id=6d78613d&scoped=true&"
import script from "./BidHistoryItem.vue?vue&type=script&lang=js&"
export * from "./BidHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./BidHistoryItem.vue?vue&type=style&index=0&id=6d78613d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d78613d",
  null
  
)

export default component.exports